import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { LOGO_URL, COMPANY } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PendingPage() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="pending-page">
      <div className="max-w-lg text-center ff-fade-in">
        <Link to="/">
          <img src={LOGO_URL} alt="FineFood Primeur" className="h-16 mx-auto" />
        </Link>
        <div className="mt-10 mx-auto w-16 h-16 bg-[#F4A261]/20 flex items-center justify-center">
          <Clock className="w-8 h-8 text-[#E76F51]" />
        </div>
        <p className="ff-overline mt-8">Compte en attente</p>
        <h1 className="font-serif text-4xl mt-3">Validation en cours</h1>
        <p className="mt-5 text-[#4A5D4E] leading-relaxed">
          Votre demande a bien été reçue. Notre équipe vérifie votre dossier sous 24h ouvrées.
          Vous recevrez une confirmation par email dès que votre compte sera activé.
        </p>
        {user && (
          <p className="mt-4 text-sm text-[#8A9A8E]" data-testid="pending-email">
            Connecté en tant que {user.email}
          </p>
        )}
        <div className="mt-10 flex justify-center gap-3">
          <a href={`tel:${COMPANY.phone}`} className="ff-btn-secondary" data-testid="pending-contact">
            Nous appeler · {COMPANY.phone}
          </a>
          <button onClick={logout} className="ff-btn-primary" data-testid="pending-logout">
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
}
